$bog_card $mol_page
	title @ \Web-development
	plugins /
		<= Theme $bog_theme_auto
	minimal_width 0
	minimal_height 0
	Head null
	body /
		<= Particles $bog_card_particles
		<= Card $mol_view sub /
			<= Header $bog_card_header
				title @ \Web Development
				subtitle @ \Creating Digital Solutions
			<= Services $mol_view
				sub /
					<= Service_tag1 $bog_card_tag text @ \Web Applications
					<= Service_tag2 $bog_card_tag text @ \SPA / PWA
					<= Service_tag3 $bog_card_tag text @ \API Development
					<= Service_tag4 $bog_card_tag text @ \UI/UX Design
					<= Service_tag5 $bog_card_tag text @ \Fullstack
			<= Divider $mol_view
			<= Contacts_title $mol_text text @ \Contact Us
			<= Contacts $mol_list
				rows /
					<= Contact_erik $bog_card_contact
						uri \https://t.me/ukmn9i5
						name @ \Erik
						username \@ukmn9i5
					<= Contact_kirill $bog_card_contact
						uri \https://t.me/dev_cmyser
						name @ \Kirill
						username \@dev_cmyser
			<= Footer $bog_card_footer
				start @ \Code with
				center @ \♥
				end @ \and coffee
